import React from "react";
import "./EducationApp.css";
import ucrmsLogo from "./assets/ucrgold.png";
import ucrbsLogo from "./assets/ucrblue.png";
import bghsLogo from "./assets/matador.png";

const EducationApp = () => {
  const educationList = [
    {
      school: "University of California, Riverside",
      degree: "Bachelor of Science in Computer Science",
      period: "Sep 2021 - Jun 2025",
      gpa: "3.92",
      logo: ucrbsLogo,
    },
    {
      school: "University of California, Riverside",
      degree: "Master of Science in Computer Science",
      period: "Sep 2025 - Jun 2026",
      gpa: "4.00",
      logo: ucrmsLogo,
    },
    {
      school: "Bolsa Grande High School",
      degree: "High School Diploma",
      period: "Aug 2017 - Jun 2021",
      gpa: "4.21",
      logo: bghsLogo,
    },
  ];

  const coursework = [
    "Machine Learning",
    "Embedded Systems",
    "Data Analytics",
    "Natural Language Processing",
    "Data Structures & Algorithms",
    "Software Construction",
    "Database Management Systems",
    "Compiler Design",
    "Operating Systems",
    "Machine Learning",
    "Web Development",
    "Computer Architecture",
  ];

  const achievements = [
    "Chancellor's Honor List",
    "Regent's Scholarship",
    "Magna Cum Laude",
  ];

  return (
    <div className="education-app">
      <div className="edu-header">
        <h2>Education</h2>
        <p>Academic Background & Achievements</p>
      </div>

      <div className="degrees-container">
        {educationList.map((education, eduIndex) => (
          <div key={eduIndex} className="degree-card">
            <div className="degree-badge">
              <img src={education.logo} alt={education.school} />
            </div>
            <div className="degree-details">
              <h3>{education.school}</h3>
              <h4>{education.degree}</h4>
              <div className="degree-meta">
                <span className="period">{education.period}</span>
                <span className="gpa">GPA: {education.gpa}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="coursework-achievements">
        <div className="coursework-section">
          <h3>Relevant Coursework</h3>
          <div className="course-grid">
            {coursework.map((course, index) => (
              <div key={index} className="course-item">
                {course}
              </div>
            ))}
          </div>
        </div>

        <div className="achievements-section">
          <h3>Achievements</h3>
          <ul className="achievements-list">
            {achievements.map((achievement, index) => (
              <li key={index}>{achievement}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EducationApp;
